import React from "react";
import { View } from "react-native";
import IconButton from "../../components/IconButton";
import type { Meta, StoryObj } from "@storybook/react";

const meta = {
    title: "Components/Icon Button",
    component: IconButton,
    argTypes: {
        disabled: {
            control: { type: "boolean" },
        },
        size: {
            options: [17, 24, 44],
            control: { type: "radio" },
        },
        mode: {
            options: ["default", "outlined", "contained"],
            control: { type: "radio" },
        },
        icon: {
            options: ["images", "search", "close", "menu"],
            control: { type: "select" },
        },
        onPress: { action: "pressed the button" },
    },
    args: {
        icon: "images",
        size: 24,
    },
    decorators: [
        (StoryFn) => (
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof IconButton>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {
        mode: "default",
    },
};

export const Outlined: Story = {
    args: {
        mode: "outlined",
    },
};

export const Contained: Story = {
    args: {
        mode: "contained",
    },
};
